import React, { useEffect, useState } from "react";
import { api, formatApiError } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Card } from "../components/ui/card";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../components/ui/dialog";
import { toast } from "sonner";
import { Boxes, Plus, Minus, Package } from "lucide-react";

export default function Stock() {
  const [products, setProducts] = useState([]);
  const [onlyLow, setOnlyLow] = useState(false);
  const [adj, setAdj] = useState(null);
  const [delta, setDelta] = useState("");
  const [note, setNote] = useState("");

  const load = () => api.get("/products", { params: { low_stock: onlyLow } }).then((r) => setProducts(r.data)).catch(() => {});
  useEffect(() => { load(); }, [onlyLow]);

  const openAdj = (p) => { setAdj(p); setDelta(""); setNote(""); };

  const save = async (sign) => {
    const d = sign * Math.abs(Number(delta) || 0);
    if (!d) { toast.error("Masukkan jumlah"); return; }
    try {
      await api.patch(`/products/${adj.id}/stock`, { delta: d, note });
      toast.success("Stok diperbarui"); setAdj(null); load();
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };

  return (
    <div className="space-y-5" data-testid="stock-page">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h1 className="font-heading text-2xl font-bold tracking-tight">Stok Barang</h1>
          <p className="text-muted-foreground text-sm">Pantau dan sesuaikan stok produk.</p>
        </div>
        <Button variant={onlyLow ? "default" : "outline"} onClick={() => setOnlyLow(!onlyLow)} className="rounded-lg" data-testid="toggle-low-stock">
          {onlyLow ? "Tampilkan Semua" : "Hanya Stok Menipis"}
        </Button>
      </div>

      <Card className="border-slate-200 rounded-xl shadow-sm overflow-hidden">
        <div className="overflow-x-auto kasir-scroll">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 text-muted-foreground">
              <tr className="text-left">
                <th className="py-3 px-4 font-medium">Produk</th>
                <th className="py-3 px-4 font-medium text-right">Stok Saat Ini</th>
                <th className="py-3 px-4 font-medium text-right">Batas Rendah</th>
                <th className="py-3 px-4 font-medium text-right">Aksi</th>
              </tr>
            </thead>
            <tbody>
              {products.map((p) => (
                <tr key={p.id} className="border-t border-slate-100 hover:bg-slate-50" data-testid={`stock-row-${p.id}`}>
                  <td className="py-3 px-4">
                    <div className="flex items-center gap-3">
                      <div className="w-8 h-8 rounded-lg bg-accent/50 flex items-center justify-center"><Package className="w-4 h-4 text-primary/40" /></div>
                      <span className="font-medium">{p.name}</span>
                    </div>
                  </td>
                  <td className="py-3 px-4 text-right">
                    <span className={`font-bold ${p.stock <= p.low_stock_threshold ? "text-amber-600" : "text-slate-800"}`}>{p.stock} {p.unit}</span>
                  </td>
                  <td className="py-3 px-4 text-right text-muted-foreground">{p.low_stock_threshold}</td>
                  <td className="py-3 px-4 text-right">
                    <Button size="sm" variant="outline" onClick={() => openAdj(p)} className="rounded-lg" data-testid={`adjust-stock-${p.id}`}>Sesuaikan</Button>
                  </td>
                </tr>
              ))}
              {products.length === 0 && <tr><td colSpan={4} className="py-12 text-center text-muted-foreground">Tidak ada data.</td></tr>}
            </tbody>
          </table>
        </div>
      </Card>

      <Dialog open={!!adj} onOpenChange={() => setAdj(null)}>
        <DialogContent data-testid="stock-dialog">
          <DialogHeader><DialogTitle className="font-heading">Sesuaikan Stok — {adj?.name}</DialogTitle></DialogHeader>
          <div className="text-sm text-muted-foreground">Stok saat ini: <b className="text-slate-800">{adj?.stock}</b></div>
          <Input type="number" value={delta} onChange={(e) => setDelta(e.target.value)} placeholder="Jumlah" className="rounded-lg" data-testid="stock-delta-input" />
          <Input value={note} onChange={(e) => setNote(e.target.value)} placeholder="Catatan (opsional)" className="rounded-lg" />
          <DialogFooter>
            <Button variant="outline" onClick={() => save(-1)} className="rounded-lg" data-testid="stock-minus-btn"><Minus className="w-4 h-4 mr-1" /> Kurangi</Button>
            <Button onClick={() => save(1)} className="rounded-lg" data-testid="stock-plus-btn"><Plus className="w-4 h-4 mr-1" /> Tambah</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
